/* eslint-disable react/display-name */
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
} from 'react';

const CustomGroupFilter = forwardRef((props, ref) => {
    const {colDef, defaultOption = '', filterChangedCallback, values} = props;
    const [filterState, setFilterState] = useState(defaultOption);
    const [searchQuery, setSearchQuery] = useState('');

    useImperativeHandle(ref, () => ({
        isFilterActive: () => filterState !== '',
     doesFilterPass: (params) => {
    return params.data[colDef.field] === filterState;
},
        getModel: () => (filterState === '' ? undefined : {state: filterState}),
        setModel: (model) => setFilterState(model?.state || ''),
        getModelAsString: () => filterState,
        onNewRowsLoaded: () => console.log('new rows were loaded'),
        onAnyFilterChanged: () => console.log('another filter was changed'),
        afterGuiAttached: () => console.log('focus something???'),
    }));

    useEffect(
        () => filterChangedCallback(),
        [filterState, filterChangedCallback]
    );

    const handleFilterChange = (value) => setFilterState(value);

    // filter the options based on the search query
    const filteredValues = values.filter((value) =>
        value.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className='mb-2 px-2'>
                <input
                    type='text'
                    placeholder='Search...'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            <div className='overflow-y-auto max-h-60'>
                {filteredValues?.length > 0 ? filteredValues.map((value) => (
                    <div
                        key={value}
                        className={`filter-entry my-1 px-2 font-medium ${
                            value === filterState ? 'text-blue-c3' : ''
                        }`}
                    >
                        <label className='flex items-center gap-2'>
                            <input
                                type='radio'
                                onChange={() => handleFilterChange(value)}
                                checked={filterState === value}
                            />
                            {value}
                        </label>
                    </div>
                )) : <p className='px-2 font-medium'>No Groups available</p>}
            </div>
        </>
    );
});

export default CustomGroupFilter;
